import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import { Container } from '@amzn/dvui/dist/Container'
import { Carousel } from '@amzn/dvui/dist/Carousel'
import { Text } from '@amzn/dvui/dist/Text'
import { SrcSize } from '../../utils/imageUtils'
import { ResponsiveImage } from '../images/responsiveImage'
import { TextLocalizer } from '../localizer/localizer'
import { CarouselCollection } from '../carousel/carouselCollection'
import { ICollection } from '../../selectors/collections'
import * as st from './castAndCrewTabs.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { IDetailPageState } from '../../reducers'
import { showCastAndCrewTabsSelector } from '../../selectors/castAndCrew'
import { pageSelectors } from '../../selectors/basicState'


const MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH = 130
const MEMBER_IMAGE_DEFAULT_WIDTH = 190

export interface Props {
  showCastAndCrewTabs: boolean,
  castAndCrew?: WpsRuntime.atv.wps.CastAndCrewWidgetModelProps
}

type CastType = {
  cast: WpsRuntime.atv.wps.Cast
  index: number
}

export const Cast = ({ cast: { imageUrl, name }, index }: CastType) => {
  const imgProps = {
    alt: '',
    src: imageUrl,
    baseValue: MEMBER_IMAGE_DEFAULT_WIDTH,
    srcSizes: [
      { 'max-phone-landscape': MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH },
    ] as SrcSize[],
    isLazy: true
  }

  const isValidImage = imageUrl && imageUrl !== '\\N'
  return (
    <label htmlFor={`cast-${index}`} className={st.castImageWrapper}>
      <div className={st.noImage}>
        <Icon className={st.sash} use={IconType.SMILE} />
      </div>
      {isValidImage && (
        <ResponsiveImage className={st.castImage} classNameContainer={st.castImage} {...imgProps} />
      )}
      <div className={st.name}>
        <p>{name}</p>
      </div>
    </label>
  )
}

type CastTitlesType = {
  castMember: WpsRuntime.atv.wps.CastMemberModel
  carouselIndex: number
}
export const CastTitles = ({
         castMember: {
           cast: { personPageLink, name, role },
           titleCollections: { collectionType, cards, totalCardSize },
         },
         carouselIndex,
       }: CastTitlesType) => {
         const collectionsProps = {
           collectionType,
           cardTitleIds: cards.map((c) => c.titleID),
           totalEpisodeSize: totalCardSize,
           index: carouselIndex,
         } as ICollection

         return (
           <>
             <input
               id={`cast-${carouselIndex}`}
               name='cnc-cast-selector'
               className={st.hiddenCastSelector}
               defaultChecked={carouselIndex === 0}
               type='radio'
             />
             <div className={st.titleSection}>
               <div className={st.carouselTitle}>
                 <span className={st.carouselTitleName}>
                   {role ? `${role} - ${name}` : name}
                 </span>
                 {personPageLink && <Text string={personPageLink} />}
               </div>
               <div className={st.titleCarouselWrapper}>
                 <CarouselCollection {...collectionsProps} />
               </div>
             </div>
           </>
         )
       }

export const ConnectedCastAndCrew = ({ castAndCrew, showCastAndCrewTabs }: Props) => {
  if (!showCastAndCrewTabs) return null

  const castMemberList = castAndCrew && castAndCrew.castAndCrews

  return  castMemberList ? (
    <Container className={`${stUtility.pageSection} cast-and-crew-section`}>
      <h1 className={st.title}>
        <TextLocalizer stringID='DV_DP_CAST_CREW_HEADING' />
      </h1>
      <div className={st.contentWrapper}>
        {castMemberList.map((castMember, idx) => (
          <CastTitles
            key={castMember.cast.name}
            castMember={castMember}
            carouselIndex={idx}
          />
        ))}
        <Carousel className={st.castCarousel}>
          {castMemberList.map((castMember, idx) => (
            <Cast
              key={`cast-${castMember.cast.imdbId}`}
              cast={castMember.cast}
              index={idx}
            />
          ))}
        </Carousel>
      </div>
    </Container>
  ) : null
}

const mapStateToProps = (state: IDetailPageState): Props => ({
  showCastAndCrewTabs: showCastAndCrewTabsSelector(state),
  castAndCrew: pageSelectors.castAndCrew(state),
})

export const CastAndCrew = connect(mapStateToProps)(
  ConnectedCastAndCrew
)

